<template>
    <el-dialog
        ref="taskDeviceDialog"
        title="绑定设备"
        width="60%"
        top="4%"
        :custom-class="'task-device-dialog'"
        :append-to-body="true"
        :visible="taskDeviceVisible"
        :close-on-click-modal="false"
        :before-close="handleClose"
    >
        <el-form
            class="form-container"
            ref="formRef"
            label-width="100px"
            :model="form"
        >
            <el-row>
                <el-col :span="8">
                    <el-form-item label="设备类型：" prop="deviceType">
                        <el-select
                            v-model="form.deviceType"
                            clearable
                            placeholder="设备类型"
                        >
                            <el-option
                                v-for="(val, key) in dictData.DEVICETYPE"
                                :key="key"
                                :label="val"
                                :value="key"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="设备号：" prop="deviceNo">
                        <el-input
                            v-model.trim="form.deviceNo"
                            placeholder="请输入设备号"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item>
                        <el-button type="primary" :loading="bindBtnLoading" @click="handleBindDevice">确认绑定</el-button>
                        <el-button type="primary" :loading="cancelBindBtnLoading" @click="handleCancelBindDevice">取消绑定</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <p class="table-title">请选择要绑定的TK单</p>
        <div class="table-wrapper">
            <el-table
                ref='mainTable'
                :data="tableData"
                border
                height="400px"
                v-loading="loading"
                show-overflow-tooltip
                tooltip-effect='dark'
                :row-key="(row) => row.tableId"
                :expand-row-keys="expandsRowKeys"
                :row-class-name="rowClass"
                @expand-change="handleExpandChange">
                <!-- <el-table-column type="selection" width="40" fixed></el-table-column> -->
                <el-table-column align="center" width="50px">
                    <template #header>
                        <el-checkbox
                            v-model="mainTableAllSelected"
                            :indeterminate="mainTableIsIndeterminate"
                            @change="() => handleMainAllSelected()"
                        ></el-checkbox>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox
                            v-model="scope.row.expandTableAllSelected"
                            :indeterminate="scope.row.expandTableIsIndeterminate"
                            :disabled="!Boolean(scope.row.detailListLength)"
                            @change="() => handleMainSelected(scope.row)"
                        ></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-table
                            :ref="'expandTable' + props.$index"
                            :data="props.row.detailList"
                            border
                            :row-key="(row) => row.tableId">
                            <el-table-column align="center" width="50px" :key="props.row.expandTableAllSelected">
                                <template #header>
                                    <el-checkbox
                                        v-model="props.row.expandTableAllSelected"
                                        :indeterminate="props.row.expandTableIsIndeterminate"
                                        @change="() => handleExpandAllSelected(props.row)"
                                    ></el-checkbox>
                                </template>
                                <template slot-scope="scope">
                                    <el-checkbox
                                        v-model="scope.row.selected"
                                        @change="() => handleExpandSelected(props.row)"
                                    ></el-checkbox>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column type="selection" width="40" fixed :reserve-selection="true"></el-table-column> -->
                            <el-table-column type="index" width="50" label="序号"></el-table-column>
                            <el-table-column label="任务号" prop="taskNo" min-width="160" show-overflow-tooltip></el-table-column>
                            <el-table-column label="客户订单号" prop="customerOrderNo" min-width="160" show-overflow-tooltip></el-table-column>
                            <el-table-column label="配送方式" prop="deliveryTypeName" min-width="100" show-overflow-tooltip></el-table-column>
                            <el-table-column label="客户" prop="customerName" min-width="180" show-overflow-tooltip></el-table-column>
                            <el-table-column label="期望送达时间" prop="expectEndTime" min-width="100" show-overflow-tooltip></el-table-column>
                            <el-table-column label="设备号" prop="deviceNo" min-width="100" show-overflow-tooltip></el-table-column>
                            <el-table-column label="绑定状态" prop="bindingDeviceFlagName" min-width="100" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                <el-table-column label="站点地址" prop="siteAddress" min-width="200"></el-table-column>
                <el-table-column label="运单数" prop="transportCount" min-width="100"></el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api.js';
import { validateBindParams, validateCancelBindParams, dealWithBindParams, dealWithCancelBindParams } from './util.js';
import { queryBindEquipment, bindEquipmentByTransport, cancelEquipmentByTransport } from '../../../../api/performanceDispatchMgmt';
export default {
    name: 'TaskDeviceDialog',
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        taskDeviceVisible: {
            type: Boolean,
            default () {
                return false;
            }
        }
    },
    data () {
        return {
            dictData: {},
            form: {
                dispatchNo: '',
                deviceType: '10',
                deviceNo: ''
            },
            tableData: [],
            loading: false,
            bindBtnLoading: false,
            cancelBindBtnLoading: false,
            expandsRowKeys: [],
            isIndeterminate: false,
            mainTableAllSelected: false, // 主表全选框 全选中状态
            mainTableIsIndeterminate: false // 主表全选框 部分选中状态
        };
    },
    async mounted () {
        this.form.dispatchNo = this.componentsData.dispatchNo;
        await this.getDicData();
        this.init();
    },
    methods: {
        /**
         * @description 获取数据字典
         * @param {string} 数据字典编码字符串
         * @return {Object} 数据字典类型集合
         */
        async getDicData () {
            const dict = await dictWithUrl(
                'DEVICETYPE,BINDING_DEVICE_FLAG,DELIVERY_TYPE'
            );
            this.dictData = dict.data;
        },
        init () {
            this.loading = true;
            this.mainTableAllSelected = false;
            this.mainTableIsIndeterminate = false;
            queryBindEquipment({ dispatchNo: this.componentsData.dispatchNo })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = this.formatTableData(res.data || [], this.dictData);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatTableData (data, dictData) {
            if (!data.length) return [];
            data.forEach((item, index) => {
                item.tableId = index + 1;
                item.detailList = JSON.parse(JSON.stringify(item.baseTransportDeviceDtoList || []));
                item.detailListLength = item.detailList.length || 0;
                this.$set(item, 'expandTableAllSelected', false);
                this.$set(item, 'expandTableIsIndeterminate', false);
                if (item.detailListLength) {
                    item.detailList.forEach((subItem, subIndex) => {
                        subItem.tableId = `${item.tableId}${subIndex}`;
                        subItem.bindingDeviceFlagName = dictData.BINDING_DEVICE_FLAG[subItem.bindingDeviceFlag] || '';
                        subItem.deliveryTypeName = dictData.DELIVERY_TYPE[subItem.deliveryType] || '';
                        this.$set(subItem, 'selected', false);
                    });
                }
            });
            return data;
        },
        // 主表 全选回调
        handleMainAllSelected () {
            this.mainTableIsIndeterminate = false;
            this.tableData.forEach(async (item) => {
                if (item.detailListLength) {
                    await this.$refs.mainTable.toggleRowExpansion(item, true);
                    this.$set(item, 'expandTableAllSelected', this.mainTableAllSelected);
                    this.$set(item, 'expandTableIsIndeterminate', false);
                    item.detailList.forEach(subItem => {
                        this.$set(subItem, 'selected', this.mainTableAllSelected);
                    });
                }
            });
        },
        // 主表 单选回调
        handleMainSelected (row) {
            this.$refs.mainTable.toggleRowExpansion(row, true);
            this.$set(row, 'expandTableIsIndeterminate', false);
            row.detailList.forEach(subItem => {
                this.$set(subItem, 'selected', row.expandTableAllSelected);
            });
            this.mainTableAllSelected = this.tableData.every(v => v.detailListLength ? v.detailList.every(v => v.selected) : true);
            this.mainTableIsIndeterminate = !this.mainTableAllSelected && this.tableData.some(v => v.expandTableAllSelected || v.expandTableIsIndeterminate);
        },
        // 扩展表 全选回调
        handleExpandAllSelected (row) {
            this.$set(row, 'expandTableIsIndeterminate', false);
            row.detailList.forEach(subItem => {
                this.$set(subItem, 'selected', row.expandTableAllSelected);
            });
            this.mainTableAllSelected = this.tableData.every(v => v.detailListLength ? v.detailList.every(v => v.selected) : true);
            this.mainTableIsIndeterminate = !this.mainTableAllSelected && this.tableData.some(v => v.expandTableAllSelected || v.expandTableIsIndeterminate);
        },
        // 扩展表 单选回调
        handleExpandSelected (row) {
            const expandAllSelected = row.detailList.every(v => v.selected);
            const expandIsIndeterminate = !expandAllSelected && row.detailList.some(v => v.selected);
            this.$set(row, 'expandTableAllSelected', expandAllSelected);
            this.$set(row, 'expandTableIsIndeterminate', expandIsIndeterminate);
            this.mainTableAllSelected = this.tableData.every(v => v.detailListLength ? v.detailList.every(v => v.selected) : true);
            this.mainTableIsIndeterminate = !this.mainTableAllSelected && this.tableData.some(v => v.expandTableAllSelected || v.expandTableIsIndeterminate);
        },
        // 确认绑定
        handleBindDevice () {
            const isValidated = validateBindParams(this.form, this.mainTableAllSelected, this.mainTableIsIndeterminate);
            if (!isValidated) return;
            const bindParams = dealWithBindParams(this.form, this.tableData);
            this.bindBtnLoading = true;
            bindEquipmentByTransport(bindParams)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('操作成功');
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.bindBtnLoading = false;
                    // 重置数据前,先将扩展表全选框重置为未选中状态(修复扩展表部分选中状态更新问题)
                    this.tableData.forEach(item => {
                        this.$set(item, 'expandTableIsIndeterminate', false);
                    });
                    this.init();
                });
        },
        // 取消绑定
        handleCancelBindDevice () {
            const isValidated = validateCancelBindParams(this.form, this.mainTableAllSelected, this.mainTableIsIndeterminate);
            if (!isValidated) return;
            const cancelBindParams = dealWithCancelBindParams(this.form, this.tableData);
            this.cancelBindBtnLoading = true;
            cancelEquipmentByTransport(cancelBindParams)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('操作成功');
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.cancelBindBtnLoading = false;
                    // 重置数据前,先将扩展表全选框重置为未选中状态(修复扩展表部分选中状态更新问题)
                    this.tableData.forEach(item => {
                        this.$set(item, 'expandTableIsIndeterminate', false);
                    });
                    this.init();
                });
        },
        rowClass ({ row }) {
            if (!row.detailListLength) {
                return 'display-icon';
            }
            return '';
        },
        handleExpandChange (row, expandedRows) {
            // var that = this;
            // that.expandsRowKeys = [];
            // if (row && expandedRows.length) {
            //     that.expandsRowKeys.push(row.expandsRandomKey);
            // }
        },
        getRowKeys (row) {
            return row.tableId;
            // if (!row.expandsRandomKey) row.expandsRandomKey = row.tableId + Math.random().toString().substr(-10);
            // row.expandsRandomKey = row.tableId;
            // return row.expandsRandomKey;
        },
        handleClose () {
            this.$emit('update:taskDeviceVisible', false);
            this.$emit("refresh");
        }
    }
};
</script>

<style lang="less">
.task-device-dialog {
    .el-dialog {
        height: 600px !important;
        overflow: scroll;
    }
    .el-select {
        width: 100%;
    }
    .el-table--border {
        border-right: 1px solid #EBEEF5 !important;
        border-bottom: 1px solid #EBEEF5 !important;
    }
    .display-icon {
        .el-table__expand-icon {
            display: none !important;
        }
    }
}
</style>
